import { useQueryUser } from '@/hooks/query/useQueryUser';
import { CodeSystem } from '@heidi/coding/contracts';
import { Badge } from '@heidi/design-system/badge';
import { useTranslations } from '@heidi/runtime/i18n';

interface HccBadgeProps {
  codeSystem: CodeSystem;
  hccCode?: number | null;
}

/**
 * Renders an "HCC {n}" badge for ICD-10-CM codes that map to a CMS-HCC V28
 * risk-adjustment category. Returns `null` for non-ICD-10-CM codes, when
 * `hccCode` is absent, or when the user has disabled HCC badges in settings.
 */
export const HccBadge = ({ codeSystem, hccCode }: HccBadgeProps) => {
  const { t } = useTranslations();
  const { data: showHccBadges } = useQueryUser((data) => data.show_hcc_badges);

  if (!showHccBadges || codeSystem !== CodeSystem.icd_10_cm || hccCode == null) {
    return null;
  }

  return (
    <Badge color="red" size="xs" className="cursor-default whitespace-nowrap">
      {t('embeddings.hccBadge', { hccCode })}
    </Badge>
  );
};
